// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"392":"ac6632cc","453":"e0bdcb9b"}[chunkId] + ".chunk.js";
};